import Link from "next/link";

// "Nohaya" wordmark, used by both the header and the footer.
export default function Logo({ className = "" }: { className?: string }) {
  return (
    <Link
      href="/"
      aria-label="Nohaya home"
      className={`text-[22px] font-extrabold tracking-[-0.04em] text-[#0b0f19] dark:text-white ${className}`}
    >
      Nohaya
    </Link>
  );
}
